<template>
    <Container>
        <div class="d-flex flex-wrap station-list-view" style="gap:14px;">
            <div
                v-for="promotion in promotions"
                :key="promotion.id"
            >
                <PromoItem :promo="promotion" />
            </div>
        </div>
    </Container>
</template>

<script>
    import { mapGetters } from 'vuex'

    import Container from '@/components/Vuetify/Container'
    import PromoItem from '@/components/app/personal/promo/PromoItem'

    export default {
        name: 'PromoScreen',

        components: {
            Container,
            PromoItem,
        },

        computed: {
            ...mapGetters({
                promotions: 'promotion/getPromotions',
            }),
        },
    }
</script>
